import { useState, useEffect } from 'react';
import { Table, Tag, Spin } from 'antd';
import { formatDate } from '../../../helpers/genericHelper';
import API from '../../../services/API';

function AllowlistedRules({ userId }) {
  const [allowlistedRules, setAllowlistedRules] = useState([]);
  const [loading, setLoading] = useState(false);

  const fetchAllowlistedRules = async () => {
    if (!userId) return;
    
    try {
      setLoading(true);
      const rules = await API.getAllowlistedRules(userId);
      setAllowlistedRules(rules || []);
    } catch (error) {
      console.error('Error fetching allowlisted rules:', error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchAllowlistedRules();
  }, [userId]);

  const isRuleActive = (expirationTs) => {
    return new Date(expirationTs) > new Date();
  };

  const columns = [
    {
      title: 'ID',
      dataIndex: 'ruleId',
      key: 'ruleId',
      render: (ruleId) => ruleId
    },    
    {
      title: 'Name',
      dataIndex: 'ruleName',
      key: 'ruleName',
      render: (ruleName) => ruleName
    },
    {
      title: 'Allowlisted Date',
      dataIndex: 'createTs',
      key: 'createTs',
      render: (date) => formatDate(date, true)
    },
    {
      title: 'Expiration Date',
      dataIndex: 'expirationTs',
      key: 'expirationTs',
      render: (date) => formatDate(date, true)
    },
    {
      title: 'Status',
      dataIndex: 'expirationTs',
      key: 'status',
      render: (expirationTs) => {
        const active = isRuleActive(expirationTs);
        return (
          <Tag color={active ? 'green' : 'red'}>
            {active ? 'Active' : 'Expired'}
          </Tag>
        );
      }
    },
    {
      title: 'Admin',
      dataIndex: 'adminId',
      key: 'adminId',
      render: (adminId, record) => record.adminName || adminId
    },
    {
      title: 'Comment',
      dataIndex: 'comment',
      key: 'comment',
      render: (comment) => comment || '–'
    }
  ];

  if (loading) {
    return (
      <div style={{ textAlign: 'center', padding: '20px' }}>
        <Spin size="large" />
      </div>
    );
  }

  return (
    <Table
      dataSource={allowlistedRules}
      columns={columns}
      rowKey="id"
      pagination={false}
      locale={{
        emptyText: 'No allowlisted rules found'
      }}
    />
  );
}

export default AllowlistedRules;